import React, { useEffect, useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { DatePicker, message} from "antd";
import Select from "react-select";
import { Link, useNavigate } from 'react-router-dom';
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { Country, State } from "country-state-city";
import { useAuth } from "../../services/authentication_API/authService";
import { doctor } from "../imagepath";
import { addreceptionist } from "../../services/doctor/reception/reception";
import { useMessageApi } from "../../services/message api/MessageProvider";


const AddReceptionist = () => {
  const { userData} = useAuth();

  const [isClicked, setIsClicked] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const onChange = (date, dateString) => {
    setIsClicked(true);
  };
  const loadFile = (event) => {
    // Handle file loading logic here
  };
  
  const [formData, setFormData] = useState({
    parent_user_id: userData?.parent_user_id,
    doctor_id: userData?.id,
    name: "",
    last_name:"",
    middle_name:"",
    mobile: "",
    email: "",
    password: "",
    confirmPassword: "",
    gender:"",
    aadhaar_card_number: "",
    date_of_birth:"",
    address:"",
    city:"",
    country:"",
    state:"",
    pincode:""
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let newErrors = {};

    
    if (!formData?.name?.trim()) {
      newErrors.name = "First Name is required";
    }
    if (!formData?.last_name?.trim()) {
      newErrors.last_name = "Last Name is required";
    }

    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    }

    if (!formData.password.trim()) {
      newErrors.password = "Password is required";
    }

    if (!formData.confirmPassword.trim()) {
      newErrors.confirmPassword = "Confirm Password is required";
    } else if (formData.confirmPassword !== formData.password) {
      newErrors.confirmPassword = "Passwords does not match";
    }

    if (!formData.aadhaar_card_number.trim()) {
      newErrors.aadhaar_card_number = "Aadhaar Number is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (eventOrValue, fieldName) => {
    setFormData((prevData) => {
      let newData = { ...prevData };
  
      // Handle normal input fields
      if (eventOrValue && eventOrValue.target) {
        const { name, value } = eventOrValue.target;
        if (name) newData[name] = value;
      }
      // Handle DatePicker or other direct value components
      else if (fieldName) {
        newData[fieldName] = eventOrValue || "";
      }
      // Handle React-Select
      else if (eventOrValue && typeof eventOrValue === "object" && "value" in eventOrValue) {
        newData[fieldName] = eventOrValue.value;
      }
  
      return newData;
    });
  };


  const [country, setCountry] = useState();
  const [statevalue, setStateValue] = useState();

  useEffect(() => {
    const states = State.getStatesOfCountry("IN"); 
    const formattedStates = states.map((state) => ({
      label: state.name,
      value: state.name,
    }));
    const options = Country.getAllCountries()?.map((country) => ({
      label: country.name,
      value: country.name,
    }));
    setCountry(options);
    setStateValue(formattedStates);
  }, []); 

  message.config({
    top: 100, // distance from top
    duration: 3,
    placement: 'topRight', // <-- key part for right side
  });
  const navigate = useNavigate();
  const messageApi = useMessageApi();

  const handleSubmit = async(e) => {
    e.preventDefault();

    e.preventDefault();
    
      if (validateForm()) {
        console.log("Form validation successfully!", formData);
        try {
          const result = await addreceptionist(formData); 
          if (result.success) {
            messageApi.open({
              type: 'success',
              content: 'Receptionist added successfully!',
            });
            navigate('/receptionistlist');
          } else {
            const errors = result?.error;
      
            Object.entries(errors).forEach(([field, messages]) => {
              const messageArray = Array.isArray(messages) ? messages : [messages];
            
              messageArray.forEach((msg) => {
                messageApi.open({
                  type: 'error',
                  content: `${field}: ${msg}`,
                  style: {
                    maxWidth: '300px',
                    minWidth: '300px',
                    textAlign: 'left',
                    wordBreak: 'break-word',
                    marginLeft: 'auto', // aligns to right in combination with topRight
                    marginRight: '0',
                  },
                });
              });
            });
            
            
          }
        } catch (error) {
          console.error("Error adding hospital:", error?.message);
          // Show error to user
        }

      } else {
        console.log("Form validation failed");
      }
  };

  
  const handleCancel = () => {
    navigate('/receptionistlist');
  };
useEffect(() => {
      const sidebar = document.getElementById("sidebar");
      if (sidebar) {
        sidebar.classList.add("sidebar-doctor");
        sidebar.id = "menu-item1"; // Change ID if needed
      }
      document.body.classList.remove("expand-menu");
    
          document.body.classList.add("mini-sidebar");
    }, []);
  return (
    <div>
      <Sidebar activeClassName="Reception" />
      <>
        <div className="page-wrapper-doctor">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                     <Link to="/receptionistlist">Receptionists </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Add Receptionist</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Receptionist Details</h4>
                          </div>
                        </div>
                        {/* <div className="col-12 col-md-13 col-xl-12">
                          <div className="form-group local-forms">
                            <label>
                              Select parent_user_id <span className="login-danger">*</span>
                            </label>
                            <Select
                              menuPosition={'fixed'}
                              name="parent_user_id"
                              defaultValue={selectedOption}
                              onChange={(selectedOption) => handleChange(selectedOption.label, "parent_user_id")}
                              options={parent_user_id}
                              menuPortalTarget={document.body}
                              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                              id="search-commodity"
                              components={{
                                IndicatorSeparator: () => null
                              }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused ?'none' : '2px solid rgba(46, 55, 164, 0.1);',
                                   boxShadow: state.isFocused ? '0 0 0 1px #2e37a4' : 'none',
                                  '&:hover': {
                                    borderColor: state.isFocused ? 'none' : '2px solid rgba(46, 55, 164, 0.1)',
                                  },
                                  borderRadius: '10px',
                                  fontSize: "14px",
                                    minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen ? 'rotate(-180deg)' : 'rotate(0)',
                                  transition: '250ms',
                                  width: '35px',
                                  height: '35px',
                                }),
                              }}
                            />
                            {errors.parent_user_id && <p style={{ color: "red" }}>{errors.parent_user_id}</p>}
                          </div>
                        </div> */}
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              First Name <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="name"
                              type="text"
                              placeholder=""
                              onChange={handleChange}
                            />
                            {errors.name && <p style={{ color: "red" }}>{errors.name}</p>}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Middle Name 
                            </label>
                            <input
                              className="form-control"
                              name="middle_name"
                              type="text"
                              placeholder=""
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Last Name <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="last_name"
                              type="text"
                              placeholder=""
                              onChange={handleChange}
                            />
                            {errors.last_name && <p style={{ color: "red" }}>{errors.last_name}</p>}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Mobile <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="mobile"
                              type="text"
                              placeholder=""
                              onChange={handleChange}
                            />
                            {errors.mobile && <p style={{ color: "red" }}>{errors.mobile}</p>}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Email <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="email"
                              type="email"
                              placeholder=""
                              onChange={handleChange}
                            />
                            {errors.email && <p style={{ color: "red" }}>{errors.email}</p>}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Password <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="password"
                              type="password"
                              placeholder=""
                              onChange={handleChange}
                            />
                            {errors.password && <p style={{ color: "red" }}>{errors.password}</p>}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Confirm Password{" "}<span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="confirmPassword"
                              type="password"
                              placeholder=""
                              onChange={handleChange}
                            />
                            {errors.confirmPassword && (<p style={{ color: "red" }}>{errors.confirmPassword}</p>)}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Aadhaar Card Number <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="aadhaar_card_number"
                              type="text"
                              placeholder=""
                              onChange={handleChange}
                            />
                            {errors.aadhaar_card_number && <p style={{ color: "red" }}>{errors.aadhaar_card_number}</p>}
                          </div>
                        </div>
                        <div className="col-12 col-md-3 col-xl-3">
                          <div className="form-group local-forms cal-icon">
                            <label>
                              Date Of Birth{" "}
                            </label>
                            <DatePicker
                              className="form-control datetimepicker"
                              selected={formData.date_of_birth}
                              onChange={(date) => handleChange(date.toISOString().split("T")[0], "date_of_birth")}
                              suffixIcon={null}
                              style={{
                                borderColor: isClicked ? '#2E37A4' : '2px solid rgba(46, 55, 164, 0.1)',
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-3 col-xl-3">
                          <div className="form-group select-gender">
                            <label className="gen-label">
                              Gender 
                            </label>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  name="gender"
                                  onChange={handleChange}
                                  value="male"
                                  className="form-check-input"
                                />
                                Male
                              </label>
                            </div>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  onChange={handleChange}
                                  value="female"
                                  name="gender"
                                  className="form-check-input"
                                />
                                Female
                              </label>
                            </div>
                          </div>
                        </div>  
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group select-gender">
                            <label className="gen-label">Status<span className="login-danger">*</span></label>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  name="status"
                                  onChange={handleChange}
                                  value="Active"
                                  className="form-check-input"
                                />
                                Active
                              </label>
                            </div>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  onChange={handleChange}
                                  value="Deactivate"
                                  name="status"
                                  className="form-check-input"
                                />
                                Deactive
                              </label>
                            </div>
                            {errors.status && (
                              <p style={{ color: "red" }}>{errors.status}</p>
                            )}
                          </div>
                          
                        </div>
                       
                        <div className="col-12 col-sm-12">
                          <div className="form-group local-forms">
                            <label>
                              Address 
                            </label>
                            <textarea
                              className="form-control"
                              name="address"
                              onChange={handleChange}
                              rows={3}
                              cols={30}
                              defaultValue={""}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              City 
                            </label>
                            <input
                              className="form-control"
                              name="city"
                              type="text"
                              placeholder=""
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              State {" "}
                            </label>
                            <Select
                              menuPosition={'fixed'}
                              name="state"
                              defaultValue={selectedOption}
                              onChange={(selectedOption) => handleChange(selectedOption.label, "state")}
                              options={statevalue}
                              menuPortalTarget={document.body}
                              id="search-commodity"
                              components={{
                                IndicatorSeparator: () => null
                              }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused ?'none' : '2px solid rgba(46, 55, 164, 0.1);',
                                   boxShadow: state.isFocused ? '0 0 0 1px #2e37a4' : 'none',
                                  '&:hover': {
                                    borderColor: state.isFocused ? 'none' : '2px solid rgba(46, 55, 164, 0.1)',
                                  },
                                  borderRadius: '10px',
                                  fontSize: "14px",
                                    minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen ? 'rotate(-180deg)' : 'rotate(0)',
                                  transition: '250ms',
                                  width: '35px',
                                  height: '35px',
                                }),
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Country 
                            </label>
                            <Select
                              menuPosition={'fixed'}
                              name="country"
                              defaultValue={selectedOption}
                              onChange={(selectedOption) => handleChange(selectedOption.label, "country")}
                              options={country}
                              menuPortalTarget={document.body}
                              id="search-commodity"
                              components={{
                                IndicatorSeparator: () => null
                              }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused ?'none' : '2px solid rgba(46, 55, 164, 0.1);',
                                   boxShadow: state.isFocused ? '0 0 0 1px #2e37a4' : 'none',
                                  '&:hover': {
                                    borderColor: state.isFocused ? 'none' : '2px solid rgba(46, 55, 164, 0.1)',
                                  },
                                  borderRadius: '10px',
                                  fontSize: "14px",
                                    minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen ? 'rotate(-180deg)' : 'rotate(0)',
                                  transition: '250ms',
                                  width: '35px',
                                  height: '35px',
                                }),
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>
                              Postal Code{" "}
                            </label>
                            <input
                              name="pincode"
                              onChange={handleChange}
                              className="form-control"
                              type="text"
                              placeholder=""
                            />
                          </div>
                        </div>
                      
                        <div className="col-12">
                          <div className="doctor-submit text-end">
                            <button
                              type="submit"
                              className="btn btn-primary submit-form me-2"
                            >
                              Submit
                            </button>
                            <button
                            type="button"
                              className="btn btn-primary cancel-form"
                              onClick={handleCancel}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

  export default AddReceptionist
